declare var Vimeo: any;
declare var Splide: any;

export default class Slideshow {

	private containerElement: HTMLElement;
	private sliders = [];

	constructor(containerElement: HTMLElement) {
		if (!containerElement) return;
		this.containerElement = containerElement;
		this.init();
	}

	private init() {

		const list = this.containerElement.querySelector('.js-slideshow-list') as HTMLElement;
		const slideCount = this.containerElement.querySelectorAll('.js-slideshow-item').length;

		if (slideCount > 1) {

			this.restrictListAndRevealItems(list);
			this.unrestrictTarget(this.containerElement);

			const slider = new Splide(this.containerElement, {
				type: 'loop',
				perPage: 1,
				perMove: 1,
				autoplay: true,
				speed: 500,
				interval: 5000,
				pagination: true,
				arrows: true,
				keyboard: 'focused',
				throttle: 100,
				arrowPath: 'M1.61,55.69a1.57,1.57,0,0,1-1-.36,1.62,1.62,0,0,1-.23-2.27L20.92,27.85.36,2.63a1.61,1.61,0,0,1,2.5-2L25.08,27.85,2.86,55.1A1.61,1.61,0,0,1,1.61,55.69Z',
				classes: {
					prev: 'c-carousel__button c-carousel__button--left js-carousel-button-left',
					next: 'c-carousel__button c-carousel__button--right js-carousel-button-right',
					slider: 'c-carousel',
					track: 'c-carousel__inner',
					list: 'c-carousel__list',
					slide: 'c-carousel__item',
					pagination: 'c-carousel__pagination',
					page: 'c-carousel__pagination-page'
				}
			});

			slider.on('mounted', () => {
				this.unrestrictList(list);
				const carouselButtons = document.querySelectorAll('.c-carousel__button svg') as NodeListOf<SVGElement>;
				for (let i = 0; i < carouselButtons.length; i++) {
					carouselButtons[i].setAttribute("viewBox", "0 0 25 56");
					carouselButtons[i].style.height = "25px";
					carouselButtons[i].style.width = "20px";
				}

				setTimeout(() => {
					this.containerElement.removeAttribute('tabindex');
					const slides = this.containerElement.querySelectorAll('.splide__slide');
					for (var i = 0; i < slides.length; i++) { slides[i].removeAttribute('tabindex'); }
				}, 1000);
			});

			slider.on('moved', (newIndex, oldIndex) => {
				if (typeof Vimeo !== 'undefined') {
					const videoIframes = this.containerElement.querySelectorAll('.c-video iframe');
					for (let i = 0; i < videoIframes.length; i++) {
						const player = new Vimeo.Player(videoIframes[i]);
						player.pause();
					}
				}
			});

			slider.mount();

			this.sliders.push(slider);

		} else {

			this.unrestrictList(list);
			this.unrestrictTarget(this.containerElement);
			this.containerElement.classList.add('c-carousel--single');

		}

		this.initVideos();
	}

	private restrictListAndRevealItems(list: HTMLElement) {
		list.style.height = list.clientHeight + "px";
		list.style.overflow = 'hidden';
		const slideshowElements = list.querySelectorAll('.js-slideshow-item') as NodeListOf<HTMLElement>;
		for (let i = 0; i < slideshowElements.length; i++) {
			slideshowElements[i].style.display = 'block';
		}
	}

	private unrestrictList(list: HTMLElement) {
		list.style.height = "auto";
		list.style.overflow = 'visible';
	}

	private unrestrictTarget(target: HTMLElement) {
		target.style.height = "auto";
	}

	private loadVimeoApi() {
		const head = document.getElementsByTagName('head')[0];
		const script = document.createElement('script');
		script.src = "https://player.vimeo.com/api/player.js";
		head.insertBefore(script, document.getElementsByTagName("script")[0]);
	}

	private initVideos() {

		const videos = this.containerElement.querySelectorAll('.js-slideshow-list .c-video');

		if (!videos.length) {
			return;
		}

		this.loadVimeoApi();

		// Lazyloaded using lazysizes
		document.addEventListener('lazyloaded', (e)=> {

			const videoIframes = this.containerElement.querySelectorAll('.js-slideshow-list iframe');

			for (let i = 0; i < videoIframes.length; i++) {
				const videoIframe = videoIframes[i];
				if (!videoIframe.classList.contains('has-init')) {
					const player = new Vimeo.Player(videoIframe[0]);
					const sliderIndex = videoIframe.closest('.js-slideshow-list').getAttribute('data-slider-index');
					const parentSlider = this.sliders[sliderIndex];
					if (parentSlider) {
						player.on('play', function () {
							parentSlider.stopAuto();
						});
					}
					videoIframe.classList.add('has-init');
				}

			}

		});

	}

}
